module.exports = __webpack_public_path__ + "img/typhoon_32_40.f20ca2c2.png";